// import classes from "./Home.module.css";
// import WelcomeMessage from "./Welcome/WelcomeMessage";
// import LeftPanel from "../../layout/leftPanel/LeftPanel";
// import BoxesContainer from "../../../SMARTCITY/components/boxesContainer/BoxesContainer";
// import Charts from "../charts/Charts";
// import styled from "styled-components";

// const Home = () => {
//   return (
//     <BoxesContainer />
//     // <div className={classes.home_container}>
//     //   <LeftPanel
//     //     open={false}
//     //     buttonExpandName={"Γραφήματα"}
//     //     className={classes.leftPanel_Charts}
//     //   >
//     //     <Charts />
//     //   </LeftPanel>
//     //   {/*<LeftPanel*/}
//     //   {/*  open={false}*/}
//     //   {/*  buttonExpandName={"Χρονοσειρές"}*/}
//     //   {/*  className={classes.horizontal_side_panel_tableau}*/}
//     //   {/*>*/}
//     //   {/*</LeftPanel>*/}
//     //   <WelcomeMessage />
//     //   <BoxesContainer />
//     // </div>
//   );
// };

// export default Home;

import WelcomeMessage from "./Welcome/WelcomeMessage";
import BoxesContainer from "../../../SMARTCITY/components/boxesContainer/BoxesContainer";
import styled from "styled-components";

const Home = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "calc(100% - 100px)",
        display: "flex",
        flexDirection: "row",
        // paddingTop: "70px",
      }}
    >
      {/*<LeftPanel*/}
      {/*  open={false}*/}
      {/*  buttonExpandName={"Γραφήματα"}*/}
      {/*  className={classes.leftPanel_Charts}*/}
      {/*>*/}
      {/*  <Charts />*/}
      {/*</LeftPanel>*/}
      {/*<LeftPanel*/}
      {/*  open={false}*/}
      {/*  buttonExpandName={"Χρονοσειρές"}*/}
      {/*  className={classes.horizontal_side_panel_tableau}*/}
      {/*>*/}
      {/*  <Tableau />*/}
      {/*</LeftPanel>*/}
      <WelcomeWrapper>
        <WelcomeMessage />
      </WelcomeWrapper>
      <BoxesContainer />
    </div>
  );
};

export default Home;

const WelcomeWrapper = styled.div`
  display: flex;
  width: 420px;

  @media only screen and (max-width: 908px) {
    display: none;
  }
`;
